<!--
 * @Author: 窦云飞 df1987131@yeah.net
 * @Date: 2022-06-29 17:31:00
 * @LastEditors: 窦云飞 df1987131@yeah.net
 * @LastEditTime: 2022-06-29 17:35:42
 * @FilePath: /cmdc-web-v/Users/douyunfei/Documents/epec-mall/pages/fusePurchaseRequest/index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>
      <fuse-purchase-request-head
              :currentMenu="currentMenu"
              ref="fusePurchaseRequestHead"
              :setCurrentMenu="setCurrentMenu"
      ></fuse-purchase-request-head>
    <div class="container">
      <fuse-purchase-order v-if="currentMenu == 0" style="margin-bottom: 30px" />
      <fuse-purchase-order-trace
              v-if="currentMenu == 1"
              style="margin-bottom: 30px"
              :setCurrentMenu="setCurrentMenu"
      />
    </div>
  </div>
</template>

<script>
import fusePurchaseOrder from './components/fusePurchaseOrder.vue';
import fusePurchaseOrderTrace from './components/fusePurchaseOrderTrace';
import menuList from './components/header-menu.vue';
import { customCategoriesList } from '@/modules/projectA/api/urlConfig';
import api from '@/modules/projectA/api/purchase';
import fusePurchaseRequestHead from './fusePurchaseRequestHead';
export default {
  name: 'index.vue',
  components: {
    fusePurchaseOrder,
    fusePurchaseOrderTrace,
    menuList,
    fusePurchaseRequestHead,
  },
  mounted() {
    this.purchaseAreaCategory();
  },
  data() {
    return {
      customCategoriesList,
      currentMenu: '0',
    };
  },
  methods: {
    setCurrentMenu(param) {
      this.currentMenu = param;
    },
    //获取已设置分类
    async purchaseAreaCategory() {
      let params = { companyId: this.$store.state.USERINFO.purchaseAreaCompanyId };
      let res = await api.purchaseAreaCategory(params);
      if (res.data.categoryList) {
        this.allCategoriesList = res.data.categoryList;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/theme.scss';
.classification-wrapper {
  position: relative;
}
.classification {
  position: relative;
  background: #fff;
  margin: 0 auto;
  .classification-content {
    margin: 0 auto;
  }
}
.classification-wrapper:after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 2px;
  background-color: $main-col;
  z-index: 1;
}
</style>
